/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-floating-promises */
import { Divider, Flex, HStack, Text, useToast } from '@chakra-ui/react'
import 'pdfjs-dist/build/pdf.worker.entry'
import React, { useEffect, useState } from 'react'
import { FaArrowLeft, FaArrowRight, FaEnvelope } from 'react-icons/fa'
import { pdfjs } from 'react-pdf'
import { useNavigate, useParams } from 'react-router-dom'
import { ButtonCmp } from '../../../../../components/ButtonCmp'
import { ElementoTooltipCmp } from '../../../../../components/ElementoTooltipCmp'
import { InputCmp } from '../../../../../components/InputCmp'
import LoadingContainer from '../../../../../components/LoadingContainer'
import { WhiteContainer } from '../../../../../components/WhiteContainer'
import { appApi } from '../../../../../services/appApi'
import { Body } from '../../../../Layouts/Body'
import { CardColaboradorSi } from '../../../components/TabelaAderencia/components/cardColabSI'
import { numberFormatter } from '../../../Dashboard'

interface IEditarPI{
  candidato: string
  email: string
  gestor: string
  gestorEmail: string
  assessmentId: string
  assessmentIdGestor: string
  empresaId: string
}

interface IListaPerfilDTO{
  totalRegistrosEncontrados: number
  totalPaginas: number
  resultadoBusca: IperfilDto2[]
}

export interface IperfilDto2 {
  assessmentId: string
  assessmentUserId: string
  email: string
  nome: string
  dataConclusao: string
  pi: number
  self: iSelf
  selo: iSelo
}

interface iSelf {
  aSigma: number
  bSigma: number
  cSigma: number
  dSigma: number
  eSigma: number
  mScore: number
}

interface iSelo {
  definicao: string
  nome: string
  urlAvatar: string
}

// interface IFormData{

//   nome: string
//   email: string
//   cpf: string
//   linkedin?: string
//   cargo?: File
//   curriculo?: File

// }
interface IAnalise {
  nome: string
  email: string
  pi: string
  cpf: string
  pdfCurriculo?: string
  linkedin?: string
  assessmentId: string
  descritivoCargo?: string
  nomeGestor: string
  emailGestor: string
  assessmentIdGestor: string
  quadroDesenvolvimento: string
  guiaRelacionamentoGestor: string
  imageSelf?: string
  nomeCargo: string
  imageSelfGestor: string
  nomeBP: string
  emailBP: string
  performance?: string
  nomeSolicitante: string
  emailSolicitante: string
  tipoCandidato: number
  nineBox?: string
}

interface iModel {
  nome: string
  cpf: string
  email: string
}

interface iModelSolicitante {
  nomeSolicitante: string
  emailSolicitante: string
}

export const SelecionarPI: React.FC = () => {
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`
  const { id } = useParams<{ id: string }>()
  const toast = useToast()
  const nav = useNavigate()
  const [TipoCandidato, setTipoCandidato] = useState(0)
  const [ModelColaborador, setModelColaborador] = useState<iModel>({ cpf: '', email: '', nome: '' })
  const [ModelGestor, setModelGestor] = useState<iModel>({ cpf: '', email: '', nome: '' })
  const [BP, setBP] = useState<iModel>({ cpf: '', email: '', nome: '' })
  const [PerfilGestor, setPerfilGestor] = useState<IperfilDto2>()
  const [Perfil, setPerfil] = useState<IperfilDto2>()
  const [pagColaborador, setPagColaborador] = useState(0)
  const [pagGestor, setPagGestor] = useState(0)
  const [IsLoading, setIsLoading] = useState(false)
  const [IsLoadingLista, setIsLoadingLista] = useState(false)
  const [IsInvalid, setIsInvalid] = useState(false)
  const [ImageSelf, setImageSelf] = useState<string>()
  const [ImageSelfGestor, setImageSelfGestor] = useState<string>()
  const [BuscarEmail, setBuscarEmail] = useState(false)
  const [BuscarEmailGestor, setBuscarEmailGestor] = useState(false)

  // const { register, handleSubmit } = useForm<IFormData>()
  const [NineBox, setNineBox] = useState('')
  const [descricaoCargo, setDescricaoCargo] = useState('')
  const [NomeCargo, setNomeCargo] = useState('')
  const [curriculo, setCurriculo] = useState('')
  const [quadroDesenvolvimento, setQuadroDesenvolvimento] = useState('')
  const [guiaRelacionamento, setGuiaRelacionamento] = useState('')
  const [urlCurriculo, setUrlCurriculo] = useState('')
  const [Model, setModel] = useState<iModelSolicitante>({ nomeSolicitante: '', emailSolicitante: '' })
  const [PI, setPI] = useState('')
  const [BuscaPI, setBuscaPI] = useState('')
  const [BuscaGestorPI, setBuscaGestorPI] = useState('')
  const [RelatorioPerformance, setRelatorioPerformance] = useState('')

  const [DadosAssessment, setDadosAssessment] = useState<IEditarPI>({ assessmentId: '', assessmentIdGestor: '', candidato: '', email: '', gestor: '', gestorEmail: '', empresaId: '' })
  const [PerfisColaborador, setPerfisColaborador] = useState<IListaPerfilDTO>({
    resultadoBusca: [],
    totalPaginas: 0,
    totalRegistrosEncontrados: 0
  })
  const [PerfisGestor, setPerfisGestor] = useState<IListaPerfilDTO>({
    resultadoBusca: [],
    totalPaginas: 0,
    totalRegistrosEncontrados: 0
  })
  useEffect(() => {
    getModel()
  }, [])

  function OnPrevPage(isColab: boolean): void {
    const perfis = isColab ? PerfisColaborador : PerfisGestor
    const pag = isColab ? pagColaborador : pagGestor
    if (pag !== 0) {
      isColab ? setPagColaborador(pag - 1) : setPagGestor(pag - 1)
    } else {
      isColab ? setPagColaborador(Math.ceil(perfis.totalRegistrosEncontrados / 28) - 1) : setPagGestor(Math.ceil(perfis.totalRegistrosEncontrados / 28) - 1)
    }
  }

  function OnNextPage(isColab: boolean): void {
    const perfis = isColab ? PerfisColaborador : PerfisGestor
    const pag = isColab ? pagColaborador : pagGestor
    if (pag < Math.ceil(perfis.totalRegistrosEncontrados / 28) - 1) {
      isColab ? setPagColaborador(pag + 1) : setPagGestor(pag + 1)
    } else {
      isColab ? setPagColaborador(0) : setPagGestor(0)
    }
  }

  function getModel(): void {
    setIsLoading(true)
    appApi.get(`api/SI/ObterPi/${id}`)
      .then((res) => {
        setDadosAssessment(res.data)
      })
      .catch((err) => console.log(err))
      .finally(() => setIsLoading(false))
  }

  const onSubmit = (): void => {
    setIsInvalid(false)

    if (PI === '' && !Perfil) {
      setIsInvalid(true)
      toast({
        title: 'Selecione o arquivo de perfil PI',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      return
    }

    const payload: IEditarPI = {
      email: DadosAssessment.email,
      assessmentId: Perfil?.assessmentId ?? '',
      assessmentIdGestor: PerfilGestor?.assessmentId ?? '',
      gestor: DadosAssessment.gestor,
      gestorEmail: DadosAssessment.gestorEmail,
      candidato: DadosAssessment.candidato,
      empresaId: DadosAssessment.empresaId

    }

    setIsLoading(true)
    try {
      appApi.put(`api/SI/EditarPi/${id}`, payload).then(r => {
        toast({
          title: 'Perfis selecionados com sucesso!',
          status: 'success',
          duration: 4000,
          position: 'top'
        })

        nav('/PRISMAH/Dashboard')
      }).catch(err => console.log(err)).finally(() => setIsLoading(false))
      // appApi.post('api/SI/Analisar', payload).then(r => console.log(r)).catch(err => console.log(err))
    } catch (err) {
      console.error(err)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    buscar(true)
  }
  , [pagColaborador])

  useEffect(() => {
    buscar(false)
  }
  , [pagGestor])

  function buscar(isColaborador: boolean): void {
    const buscaPorEmail = BuscarEmail || BuscarEmailGestor
    const nome = isColaborador ? BuscaPI : BuscaGestorPI
    if (nome === '') return
    setIsLoadingLista(true)
    appApi.get(`api/SI/BuscaPI?nome=${nome}&tamanho=${28}&pagina=${isColaborador ? pagColaborador : pagGestor}&exibirDefinicaoSelo=true&empresaId=${DadosAssessment.empresaId}`).then(res => {
      if (res.status === 200) {
        const data: IListaPerfilDTO = res.data
        isColaborador ? setPerfisColaborador(data) : setPerfisGestor(data)
        setIsLoadingLista(false)
      }
    }).catch(err => console.log(err))
  }

  function GetPerfis(): any {
    return <>
      <Flex gap={'.325rem'}>
        Colaborador:
        <strong>{Perfil?.nome ?? 'Escolha pendente*'}</strong>
      </Flex>
      <Flex gap={'.325rem'}>
        Gestor:
        <strong>{PerfilGestor?.nome ?? 'Escolha pendente*'}</strong>
      </Flex>
    </>
  }

  return (
    <LoadingContainer linhas={42} loading={IsLoading} px='3rem' my='3rem'>
      <Body isLoading={IsLoading}>
        <WhiteContainer margin='.5rem 0 1rem 0'>
          <Flex direction='column' minHeight={'400px'} gap={'1.25rem'}>
            <Flex flexDir={'column'}>
              <h2>Seleção de perfil PI - PRISMAH</h2>
              <Text fontSize={'14px'} fontWeight={400} color={'var(--Gray2)'}>Selecione o candidato e o gestor da vaga</Text>
            </Flex>

            <InputCmp
              label='Nome do candidato'
              errorBorderColor='red.300'
              value={DadosAssessment.candidato}
              OnChange={(s) => console.log(s)}
              placeholder='Digite o email do candidato' />

            <InputCmp
              label='Email do candidato'
              value={DadosAssessment.email}
              OnChange={(s) => console.log(s)}
              />

            {/* <SwitchCmp OnChange={(val) => val ? setTipoCandidato(1) : setTipoCandidato(0) } legendaEsquerda='Candidato Interno' legendaDireita='Candidato Externo' value={TipoCandidato === 1}/> */}

            <InputCmp
              label='Buscar no PI'
              errorBorderColor='red.300'
              value={BuscaPI}
              OnChange={(s) => setBuscaPI(s)}
              placeholder='Digite o nome ou email' />

            <Flex justifyContent={'center'} alignItems={'center'} my={'.75rem'} gap={'1rem'}>

              <ElementoTooltipCmp label={BuscaPI === '' ? 'Preencha o nome do candidato ou email para pesquisar os perfis PI' : ''} bg={'var(--Red)'}>
                <ButtonCmp leftIcon={<FaEnvelope/>} w='16rem' isDisabled={BuscaPI === ''} onClick={() => { pagColaborador !== 0 ? setPagColaborador(0) : buscar(true) }} VarColor='Azul'>
                    Procurar PI do candidato
                </ButtonCmp>
              </ElementoTooltipCmp>
              <ElementoTooltipCmp label={!Perfil ? 'Ainda não foi selecionado nenhum perfil PI do candidato' : ''} bg={'var(--Red)'}>
                <ButtonCmp VarColor='Rosa' isDisabled={!Perfil} onClick={() => setPerfil(undefined)}>Limpar seleção de PI do colaborador</ButtonCmp>
              </ElementoTooltipCmp>
            </Flex>

            <LoadingContainer linhas={10} loading={IsLoadingLista}>
              {!Perfil && PerfisColaborador.resultadoBusca.length > 0 && <Flex direction={'column'} gap={'.75rem'} minH='22.5rem' maxH={'22.5rem'} overflowY={'auto'} boxShadow={'var(--SombraBackground)'} border={'1px solid var(--c5)'} p={'1rem .5rem'}>
                {PerfisColaborador.resultadoBusca.map((j, i) =>
                  <Flex>
                    <CardColaboradorSi
                      perfil={j}
                      selecionado={false}
                      onSelect={() => {
                        setPerfil(j)
                      }}
                      key={j.assessmentUserId}
                      par={i % 2 !== 0}
                    />
                  </Flex>
                )}
              </Flex>}
            </LoadingContainer>
            {!Perfil && PerfisColaborador.totalRegistrosEncontrados > 0 && <Flex justifyContent={'end'}>
              <HStack mt={0} mx={'1.25rem'} p={'.25rem'} fontSize={'.875rem'}>
                <Text>Página:</Text>
                <ButtonCmp size={'xs'} h={'1.5rem'} w={'2rem'} onClick={() => OnPrevPage(true)} VarColor='Green2'><FaArrowLeft/></ButtonCmp>
                <Text>{numberFormatter.format(pagColaborador + 1)} / {Math.ceil(PerfisColaborador.totalRegistrosEncontrados / 28)}</Text>
                <ButtonCmp size={'xs'} h={'1.5rem'} w={'2rem'} onClick={() => OnNextPage(true)} VarColor='Green2'><FaArrowRight/></ButtonCmp>
              </HStack>
            </Flex>}
            {Perfil && <CardColaboradorSi
              perfil={Perfil}
              selecionado={true}
              onSelect={() => {
                setPerfil(Perfil)
              }}
              key={Perfil.assessmentUserId}
              par
              />}
            <Divider opacity={'.8'} borderColor={'var(--Azul)'} my={'.75rem'}/>

            <Divider opacity={'.9'} borderColor={'var(--c6)'} mt={'.75rem'}/>

            <InputCmp
              label='Nome do gestor'
              OnChange={(s) => console.log(s)}
               placeholder='Digite o nome do gestor'
               value={DadosAssessment.gestor}
                />

            <InputCmp
              label='Email do gestor'
              OnChange={(s) => console.log(s)}
              value={DadosAssessment.gestorEmail}
              placeholder='Digite o email do gestor' />
                   <InputCmp
              label='Buscar no PI'
              errorBorderColor='red.300'
              value={BuscaGestorPI}
              OnChange={(s) => setBuscaGestorPI(s)}
              placeholder='Digite o nome ou email do gestor' />

            <Flex justifyContent={'center'} alignContent={'center'} my={'.75rem'} gap={'1rem'}>

              <ElementoTooltipCmp label={BuscaGestorPI === '' ? 'Preencha o nome do gestor ou Email para pesquisar os perfis PI' : ''} bg={'var(--Red)'}>
                <ButtonCmp leftIcon={<FaEnvelope/>} isDisabled={BuscaGestorPI === ''} w='16rem' onClick={() => { pagGestor !== 0 ? setPagGestor(0) : buscar(false) }} VarColor='Azul'>
                    Procurar PI do gestor
                </ButtonCmp>
              </ElementoTooltipCmp>
              <ElementoTooltipCmp label={!PerfilGestor ? 'Ainda não foi selecionado nenhum perfil PI do gestor' : ''} bg={'var(--Red)'}>
                <ButtonCmp VarColor='Rosa' isDisabled={!PerfilGestor} onClick={() => setPerfilGestor(undefined)}>Limpar seleção de PI do gestor</ButtonCmp>
              </ElementoTooltipCmp>
            </Flex>
            <LoadingContainer linhas={10} loading={IsLoadingLista}>
              {!PerfilGestor && PerfisGestor.resultadoBusca.length > 0 && <Flex direction={'column'} gap={'.75rem'} maxH={'22.5rem'} overflowY={'auto'} boxShadow={'var(--SombraBackground)'} border={'1px solid var(--c5)'} p={'1rem .5rem'}>
                {PerfisGestor.resultadoBusca.map((j, i) =>
                  <Flex>
                    <CardColaboradorSi
                      perfil={j}
                      selecionado={false}
                      onSelect={() => {
                        setPerfilGestor(j)
                      }}
                      key={j.assessmentUserId}
                      par={i % 2 !== 0}
                    />
                  </Flex>
                )}
              </Flex>}
            </LoadingContainer>
            {!PerfilGestor && PerfisGestor.totalRegistrosEncontrados > 0 && <Flex justifyContent={'end'}>
              <HStack mt={0} mx={'1.25rem'} p={'.25rem'} fontSize={'.875rem'}>
                <Text>Página:</Text>
                <ButtonCmp size={'xs'} h={'1.5rem'} w={'2rem'} onClick={() => OnPrevPage(false)} VarColor='Green2'><FaArrowLeft/></ButtonCmp>
                <Text>{numberFormatter.format(pagGestor + 1)} / {Math.ceil(PerfisGestor.totalRegistrosEncontrados / 28)}</Text>
                <ButtonCmp size={'xs'} h={'1.5rem'} w={'2rem'} onClick={() => OnNextPage(false)} VarColor='Green2'><FaArrowRight/></ButtonCmp>
              </HStack>
            </Flex>}
            {PerfilGestor && <CardColaboradorSi
              perfil={PerfilGestor}
              selecionado={true}
              onSelect={() => {
                setPerfilGestor(PerfilGestor)
              }}
              key={PerfilGestor.assessmentUserId}
              par
              />}
          </Flex>

          {/* <Flex flexDir={'column'} gap={'1.75rem'} mt={'1rem'}>
            <Text fontWeight={700} fontSize={'18px'}>Arquivos caso não selecione PI do gestor e do colaborador</Text>
            <Flex alignItems={'center'} justifyContent={'space-between'} flexWrap={'wrap'}>
              <BoxArquivo
                title='PI'
                isOpcional={true}
                AtualizarArquivo={handleFilePiChange}
                id={'filePI'}
                tipo={1}
              />
              <BoxArquivo
                isOpcional={true}
                title='PI - Quadro de desenvolvimento'
                AtualizarArquivo={handleFilePiQuadro}
                id={'filePIQuadro'}
                tipo={1}
              />
              <BoxArquivo
                isOpcional={true}
                title='PI do Gestor'
                AtualizarArquivo={handleFilePiGestorChange}
                id={'filePIGestor'}
                tipo={1}
              />
            </Flex>
          </Flex> */}

        </WhiteContainer>
        <Flex justifyContent={'end'} pb={(Perfil ?? PerfilGestor) ? '3rem' : ''}>
          <ButtonCmp leftIcon={<FaEnvelope/>} onClick={onSubmit} VarColor='Rosa' size='xs' w='16rem'>
            Processar relatório PRISMAH
          </ButtonCmp>
        </Flex>
      </Body>
      {(Perfil ?? PerfilGestor) && <Flex borderTop={'1px solid var(--c6)'} bg={'white'} pos={'fixed'} bottom={'0'} w={'100%'} py={'1rem'}justifyContent={'center'} gap={'3rem'}>
        {GetPerfis()}
      </Flex>}
    </LoadingContainer>
  )
}
